import EmptyState from "../store/emptyState";
import { RealityCheckActionConstants } from "../action-constants";
import globalReducerHelper from "./globalReducerHelper";

const { SHOW_POPUP, HIDE_POPUP, SET_SPORT_SESSION_DETAILS } =
  RealityCheckActionConstants;

const realityCheck = (state = EmptyState.realityCheck, action) => {
  if (!state) return {};

  const { type, payload } = action;

  switch (type) {
    case SHOW_POPUP: {
      return Object.assign({}, state, {
        show: true,
        netLossAmount: action.payload
      });
    }
    case HIDE_POPUP: {
      return Object.assign({}, state, {
        show: false,
        netLossAmount: null
      });
    }
    case SET_SPORT_SESSION_DETAILS: {
      return Object.assign({}, state, {
        sportSessionDetails:
          payload && payload.ExternalSessionActivationTime
            ? {
                sessionActivationTime: new Date(
                  payload.ExternalSessionActivationTime
                ).getTime()
              }
            : { sessionActivationTime: null }
      });
    }

    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.realityCheck,
        EmptyState.realityCheck
      );
  }
};

export default realityCheck;
